/* eslint-disable react/no-array-index-key */
import { useTranslation } from 'react-i18next';
import { noDp } from '../../../../helpers/helpers';

const TabSongs = ({ result }) => {
  const { t } = useTranslation('other');
  let songs = [];
  if (result?.body?.aggregations?.Songs) {
    songs = result?.body?.aggregations?.Songs.buckets.slice(0, 5);
  }

  return (
    <div className="p-4  h-full flex items-start flex-col">
      <h1 className="text-xl font-medium text-sentric-table-text mb-4">{t('other:songs-tab-header')}</h1>
      {songs.map((s, i) => (
        <div className={`h-12 ${i < (songs.length - 1) ? 'border-b' : ''} flex w-full items-center justify-items-start`} key={`song${i}`}>
          <div className="text-xs bg-gray-300 text-white rounded-full w-4 h-4 mr-2">{(i + 1)}</div>
          <div className="text-sentric-table-text text-left text-xs w-7/12 font-semibold">{s.SongTitle.buckets[0].key}</div>
          <div className="text-sentric-table-text text-xs w-4/12">
            &pound;
            {noDp(s.SongValues.value)}
          </div>

        </div>
      ))}
    </div>
  );
};

export default TabSongs;
